import { memo } from 'react';
import { Empty, Spin, Table } from 'antd';
import moment from 'moment';
import ExportExcel from '../../commonComponents/Export-Excel';

function formatTime(value) {
    if (!value) return '';
    const local = moment.utc(value).local();
    if (!local.isValid()) return '';
    return local.format('YYYY-MM-DD HH:mm:ss');
}

function tableRows(groups) {
    const rows = [];
    (groups || []).forEach(group => {
        (group.users || []).forEach((user, index) => {
            rows.push({
                key: `${group.sessionId || ''}-${user.email || user.name || index}`,
                sessionId: group.sessionId || '',
                name: user.name || '',
                email: user.email || '',
                firstAt: user.firstAt,
                lastAt: user.lastAt,
            });
        });
    });
    return rows;
}

function excelRows(rows, firstLabel, lastLabel) {
    return rows.map(row => ({
        'Session ID': row.sessionId,
        Name: row.name,
        Email: row.email,
        [firstLabel]: formatTime(row.firstAt),
        [lastLabel]: formatTime(row.lastAt),
    }));
}

function columnsFor(firstLabel, lastLabel) {
    return [
        { title: 'Session ID', dataIndex: 'sessionId', render: value => value || '—' },
        { title: 'Name', dataIndex: 'name', render: value => value || '—' },
        { title: 'Email', dataIndex: 'email', render: value => value || '—' },
        { title: firstLabel, dataIndex: 'firstAt', render: value => formatTime(value) || '—' },
        { title: lastLabel, dataIndex: 'lastAt', render: value => formatTime(value) || '—' },
    ];
}

function PiiUsersModal({
    loading,
    groups,
    firstLabel = 'First PII done',
    lastLabel = 'Last PII done',
    fileName = 'pii-users',
    emptyText = 'No PII sessions for this date',
}) {
    const rows = tableRows(groups);
    const columns = columnsFor(firstLabel, lastLabel);
    return (
        <div>
            <div className="pii-users-bar">
                <span>
                    {rows.length} {rows.length === 1 ? 'person' : 'people'}
                </span>
                {rows.length > 0 && (
                    <ExportExcel buttonSize="middle" buttonText="Export Excel" excelData={excelRows(rows, firstLabel, lastLabel)} fileName={fileName} />
                )}
            </div>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
                    <Spin />
                </div>
            ) : rows.length ? (
                <Table size="small" bordered pagination={false} columns={columns} dataSource={rows} rowKey="key" scroll={{ y: '52vh' }} />
            ) : (
                <Empty description={emptyText} />
            )}
        </div>
    );
}

export default memo(PiiUsersModal);
